import React from 'react';
import Footer from '../components/Footer';

const Verticals = () => {
  const verticals = [
    {
      image: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763271/Screenshot_2026-01-03_at_3.39.41_PM_xk8hsl_g1h3tf.png',
      title: 'Imperier Advisory Services',
      description: 'Imperier Advisory Services is the financial and capital markets advisory arm of Imperier Holdings. Built on a foundation of in-depth research, market expertise, and disciplined strategy, the advisory vertical supports investors in navigating the Indian capital markets with clarity and confidence. In collaboration with regulated broker partners such as Monarch Network Capital and Algoquant Fintech, Imperier Advisory provides access to trading platforms, market insights, and structured investment strategies. Our services span equity markets, portfolio advisory, investment planning, and tailored strategies for individuals, institutions, and corporate clients. At Imperier Advisory, the focus is on informed decision-making, risk-aware strategies, and sustainable wealth creation over the long term.',
      link: null
    },
    {
      image: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763273/Screenshot_2026-01-03_at_3.39.53_PM_og2qa1_mmmolj.png',
      title: 'Imperier Estates',
      description: 'Imperier Estates is the real assets and property advisory vertical of Imperier Holdings, offering end-to-end real estate consulting across global markets, with a strong focus on Dubai. We support clients across the entire real estate journey—from acquisition and investment planning to portfolio diversification and resale—by combining market intelligence, strategic advisory, and access to trusted developer networks. Through partnerships with leading developers such as Emaar, Sobha, and DAMAC, Imperier Estates ensures clients receive exclusive access to high-quality opportunities and transparent execution. Our approach to real estate is guided by fundamentals, long-term value, and a deep understanding of global investor needs.',
      link: null
    },
    {
      image: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763276/Screenshot_2026-01-03_at_3.40.15_PM_zddkv1_nr5xbj.png',
      title: 'Imperier Syndicate',
      description: 'Imperier Syndicate is the venture investment vertical of Imperier Holdings, designed to bring together family offices, angel investors, corporate partners, and strategic capital providers. The Syndicate focuses on early and growth-stage businesses with scalable models and strong leadership, particularly across Emerging India and underrepresented markets. Beyond capital, Imperier Syndicate supports founders through mentorship, governance participation, ecosystem access, and long-term strategic guidance. By pooling capital, expertise, and networks, the Syndicate enables collaborative investing while supporting entrepreneurs in building resilient, future-ready companies.',
      link: null
    },
    {
      image: 'https://res.cloudinary.com/ditcmszc1/image/upload/v1769763271/Screenshot_2026-01-03_at_3.39.25_PM_akjn7t_m66b5u.png',
      title: 'Brunch Club Hospitality',
      description: 'Brunch Club Hospitality is Imperier\'s lifestyle and hospitality vertical, dedicated to creating thoughtfully curated dining and social experiences. We focus on building brands that combine strong culinary identity, warm hospitality, and distinctive ambience—where every detail is designed to elevate the guest experience. Our philosophy goes beyond food. Each Brunch Club concept is crafted as a destination—bringing together comfort, creativity, and culture. From concept development to execution, we prioritise quality, consistency, and innovation across our portfolio. Through a growing collection of hospitality brands, Brunch Club Hospitality reflects Imperier\'s commitment to building experiential platforms that resonate with modern consumers and create lasting brand value.',
      link: 'https://brunchclubhospitality.com'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold text-black mb-12 text-center opacity-0 animate-fade-in-up">VERTICALS</h1>
          
          {/* Description */}
          <div className="max-w-5xl mx-auto mb-20 opacity-0 animate-fade-in-up delay-200">
            <p className="text-xl text-gray-700 leading-relaxed text-center">
              Imperier Holdings operates as a multi-vertical investment and advisory platform, structured to engage across diverse sectors, asset classes, and business models. Through its focused verticals—spanning venture investing, strategic advisory, real assets, and community-led platforms—Imperier combines disciplined capital deployment with active involvement and long-term perspective. This integrated structure allows us to identify opportunities, support growth, and create enduring value across markets and economic cycles.
            </p>
          </div>

          {/* Verticals Detailed Cards */}
          <div className="space-y-24">
            {verticals.map((vertical, index) => (
              <div
                key={index}
                className={`grid md:grid-cols-2 gap-12 items-center opacity-0 ${
                  index % 2 === 0 ? 'animate-slide-in-left' : 'animate-slide-in-right'
                } delay-${(index + 1) * 100}`}
              >
                {/* Image - Left for even, Right for odd */}
                <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                  <div className="relative group overflow-hidden rounded-lg shadow-2xl">
                    {vertical.link ? (
                      <a
                        href={vertical.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block"
                      >
                        <img
                          src={vertical.image}
                          alt={vertical.title}
                          className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-6">
                          <span className="text-white text-lg font-semibold">Visit Website →</span>
                        </div>
                      </a>
                    ) : (
                      <img
                        src={vertical.image}
                        alt={vertical.title}
                        className="w-full h-auto object-cover"
                      />
                    )}
                  </div>
                </div>

                {/* Content - Right for even, Left for odd */}
                <div className={`${index % 2 === 1 ? 'md:order-1' : ''} space-y-6`}>
                  <div className={`inline-block px-4 py-2 ${
                    index % 4 === 0 
                      ? 'bg-lightBlue/20' 
                      : index % 4 === 1 
                      ? 'bg-darkBlue/20' 
                      : index % 4 === 2 
                      ? 'bg-grey/40' 
                      : 'bg-lightBlue/30'
                  } rounded-md mb-2`}>
                    <span className="text-xs font-semibold tracking-wider text-darkBlue uppercase">
                      {index === 0 ? 'Financial Advisory' : index === 1 ? 'Real Estate' : index === 2 ? 'Venture Capital' : 'Hospitality'}
                    </span>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-black">
                    {vertical.title}
                  </h2>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {vertical.description}
                  </p>
                  {vertical.link && (
                    <div className="pt-4">
                      <a
                        href={vertical.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center space-x-2 text-black font-semibold hover:text-lightBlue transition-colors duration-300 group"
                      >
                        <span>Explore {vertical.title}</span>
                        <svg
                          className="w-5 h-5 transform group-hover:translate-x-2 transition-transform duration-300"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 8l4 4m0 0l-4 4m4-4H3"
                          />
                        </svg>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="my-20 border-t border-grey/30"></div>

          {/* Bottom CTA */}
          <div className="text-center max-w-3xl mx-auto opacity-0 animate-fade-in-up delay-400">
            <h3 className="text-2xl font-bold text-black mb-4">
              Integrated Platform, Unified Vision
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Together, these verticals form a cohesive ecosystem built on shared values of discipline, transparency, and long-term thinking. Whether through capital markets, real estate, venture investing, or hospitality, Imperier remains committed to creating lasting value across diverse opportunities.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Verticals;

